import { Grid } from 'src/design/atoms/Grid';
import { Text } from 'src/design/atoms/Text';
import { Table } from 'src/design/molecules/Table';
import React from 'react';
import { Link } from 'react-router-dom';
import { useMilestoneItemLinks } from 'src/api/queries/milestones/useMilestoneItems';

export interface ILinksProps {
  jobId: number;
  itemId: string;
}

export const Links: React.FC<ILinksProps> = ({ jobId, itemId }) => {
  const links = useMilestoneItemLinks(jobId, itemId).data ?? [];
  const renderLinks = () => {
    return links.map((s) => {
      return (
        <tr key={s.id}>
          <td>
            <Link to={`/jobs/${jobId}/${s.resource}/${s.id}`}>
              {s.itemNumber}
            </Link>
          </td>
          <td>{s.status}</td>
        </tr>
      );
    });
  };
  if (links.length === 0) return null;
  return (
    <div style={{ marginBottom: 20 }}>
      <Grid>
        <Grid.Col>
          <Text fw={700} c="bright" mb={0}>
            Links ({links.length})
          </Text>
        </Grid.Col>
      </Grid>
      <hr style={{ marginTop: 3 }} />
      <Table
        striped
        highlightOnHover
        withTableBorder
        withColumnBorders
        style={{ width: '100%' }}
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>{renderLinks()}</tbody>
      </Table>
    </div>
  );
};
